import Const from 'constants';
import history from 'helpers/history-browser';

export const redirectMiddleware = (store) => (next) => (action) => {
    if (action.type === Const.ROUTING) {
        history.push(action.payload.nextUrl);
    }

    return next(action);
};
